(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arbeli-product-card')) {
    customElements.define('arbeli-product-card', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.pair = this.querySelector('.arbeli-card-pair');
        if (!this.pair) return;
        this.views = this.querySelector('.arbeli-card-views');
        this.index = 0;
        const link = this.querySelector('.pro-img');
        const mobile = () => matchMedia('(max-width: 1024px), (hover: none), (pointer: coarse)').matches;
        link.addEventListener('pointerenter', event => {
          if (!mobile() && event.pointerType === 'mouse') this.loadSecond().catch(() => {});
        });
        link.addEventListener('focus', () => { if (!mobile()) this.loadSecond().catch(() => {}); });
        if (!this.views) return;
        this.views.hidden = false;
        ['pointerdown', 'pointerup', 'touchstart', 'touchend'].forEach(type => this.views.addEventListener(type, event => event.stopPropagation(), { passive: true }));
        this.views.addEventListener('click', event => {
          const button = event.target.closest('[data-card-index]');
          if (!button) return;
          event.preventDefault(); event.stopPropagation();
          const keyboard = event.detail === 0;
          this.selectView(Number(button.dataset.cardIndex)).then(() => { if (keyboard && button.hidden) this.views.querySelector('button:not([hidden])').focus(); });
        });
        ['touchstart', 'touchmove', 'touchend'].forEach(type => link.addEventListener(type, event => { if (mobile()) event.stopPropagation(); }, { passive: true }));
        link.addEventListener('dragstart', event => { if (mobile()) event.preventDefault(); });
        link.addEventListener('pointerdown', event => {
          if (!mobile() || !event.isPrimary || event.button !== 0) return;
          this.start = { x: event.clientX, y: event.clientY, id: event.pointerId };
          event.stopPropagation();
          link.setPointerCapture(event.pointerId);
        });
        link.addEventListener('pointermove', event => {
          if (!this.start || this.start.id !== event.pointerId) return;
          const dx = event.clientX - this.start.x, dy = event.clientY - this.start.y;
          if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.3) this.suppressClickUntil = Date.now() + 700;
        });
        link.addEventListener('pointerup', event => {
          if (!this.start || this.start.id !== event.pointerId) return;
          const dx = event.clientX - this.start.x, dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) >= 24 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            this.suppressClickUntil = Date.now() + 700;
            event.preventDefault(); event.stopPropagation();
            this.selectView(dx < 0 ? 1 : 0);
          }
        });
        link.addEventListener('pointercancel', () => { this.start = null; });
        link.addEventListener('click', event => {
          if (Date.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, true);
      }
      async selectView(index) {
        this.requested = index;
        const status = this.views.querySelector('[role="status"]');
        if (index === 1) {
          status.textContent = 'Bild wird geladen …';
          this.pair.setAttribute('aria-busy', 'true');
          try { await this.loadSecond(); }
          catch (_) {
            this.pair.removeAttribute('aria-busy');
            if (this.requested === index) status.textContent = 'Bild konnte nicht geladen werden. Bitte erneut versuchen.';
            return;
          }
        }
        if (this.requested !== index) return;
        this.index = index;
        this.pair.removeAttribute('aria-busy');
        this.pair.toggleAttribute('data-second-selected', index === 1);
        this.pair.querySelector('.arbeli-card-cover').setAttribute('aria-hidden', String(index === 1));
        const image = this.pair.querySelector('.arbeli-card-hover');
        if (image) image.setAttribute('aria-hidden', String(index !== 1));
        this.views.querySelectorAll('button').forEach(button => { button.hidden = Number(button.dataset.cardIndex) === index; });
        const side = index ? this.pair.dataset.hoverSide : this.pair.dataset.coverSide;
        status.textContent = side + ' angezeigt';
      }
      loadSecond() {
        if (this.loading) return this.loading;
        const template = this.pair.querySelector('template');
        if (!template) return Promise.resolve();
        const image = template.content.firstElementChild.cloneNode(true);
        image.sizes = Math.ceil(this.pair.getBoundingClientRect().width) + 'px';
        this.loading = new Promise((resolve, reject) => {
          image.onload = () => resolve();
          image.onerror = () => { image.remove(); this.loading = null; reject(new Error('Image unavailable')); };
          this.pair.appendChild(image);
        });
        return this.loading;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
